import { ICalendarSource } from '../data/entities/calendar-source';
import { IConfiguredHttp } from './http';

export interface ICalendarSourceApi {
	getCalendarSources: (propertyId: string | number) => Promise<ICalendarSource[]>;
	getIcalSources: (propertyId: string | number) => Promise<ICalendarSource[]>;
	createCalendarSource: (propertyId: string | number, calendarSource: ICalendarSource) => Promise<ICalendarSource>;
	deleteCalendarSource: (propertyId: string | number, calendarSourceId: number) => Promise<any>;
}

const calendarSourceApiFactory = (http: IConfiguredHttp, prefix = ''): ICalendarSourceApi => ({
	getCalendarSources(propertyId) {
		return http.get(`${prefix}/property/${propertyId}?with_activity=true`);
	},
	getIcalSources(propertyId) {
		return http.get(`${prefix}/property/${propertyId}/type/ical?with_activity=true`);
	},
	createCalendarSource(propertyId, calendarSource) {
		return http.post(`${prefix}/property/${propertyId}`, calendarSource);
	},
	deleteCalendarSource(propertyId, calendarSourceId) {
		return http.delete(`${prefix}/property/${propertyId}/id/${calendarSourceId}`);
	},
});

export default calendarSourceApiFactory;
